export default __webpack_public_path__ + "img/ffdc4c6785a4abe8ed45903220b1ba7f.svg";